var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportNumbers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_937_2538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5 45.1563C50.4219 43.9844 49.875 42.8906 49.0156 42.1875L32.6094 28.125C34.6406 25.2344 35.6563 21.875 35.7344 18.2813C35.7344 9.45314 28.9375 1.71877 20.2656 0.703144C14.9531 1.92523e-05 9.71876 1.71877 5.89063 5.46877C2.06251 9.14064 0.109381 14.2969 0.578131 19.6094C0.890631 23.8281 2.84376 27.8906 5.96876 30.8594V42.7344C5.73438 43.2031 4.64063 44.7656 2.14063 44.7656H1.59376V49.4531H30.6563V44.7656H30.1094C27.6094 44.7656 26.5156 43.125 26.2813 42.7344V36.7188L25.8906 36.5625C25.7344 36.4844 24.5625 36.0938 23.2344 34.9219C25.1094 34.375 26.9063 33.4375 28.5469 32.2656L43.2344 48.125C44.0156 48.9844 45.1094 49.5313 46.2813 49.5313H46.3594C47.4531 49.5313 48.5469 49.0625 49.3281 48.2813C50.1094 47.4219 50.5781 46.25 50.5 45.1563ZM29.5625 45.9375V48.3594H2.76563V45.9375C5.26563 45.7031 6.51563 44.1406 6.90626 43.4375H25.3438C25.8125 44.1406 27.0625 45.7031 29.5625 45.9375ZM25.1094 37.5V42.2656H7.14063V28.9063C7.14063 13.5938 14.7969 10.2344 17.4531 9.53127C17.375 10.1563 17.4531 10.7031 17.8438 11.0938C18.3906 11.7188 19.1719 11.7969 19.6406 11.7188L25.7344 19.1406C26.0469 19.6875 26.2031 20.3125 26.0469 20.9375C25.8906 21.5625 25.5 22.1094 24.9531 22.4219L24.5625 22.6563C23.3125 22.0313 18.3125 20.0781 14.7969 23.75L15.6563 24.5313C16.5156 23.6719 17.375 23.2031 18.3125 22.8906C17.2969 33.125 23.5469 36.7188 25.1094 37.5ZM48.4688 47.4219C47.8438 48.0469 47.0625 48.3594 46.2031 48.3594C45.3438 48.3594 44.5625 47.9688 44.0156 47.3438L28.7031 30.7031L28.3125 31.0156C26.5156 32.4219 24.5625 33.3594 22.375 33.9844C20.5781 31.9531 18.8594 28.4375 19.5625 22.8125C22.0625 22.6563 24.25 23.8281 24.4063 23.9063L24.7188 24.0625L25.6563 23.4375C26.4375 22.8906 26.9844 22.1094 27.2188 21.1719C27.4531 20.2344 27.2969 19.2969 26.6719 18.4375L20.1094 10.4688C19.5625 10.5469 19.0938 10.625 18.7031 10.3125C18.5469 10.0781 18.5469 9.60939 18.7813 8.98439L19.0938 8.12502L18.1563 8.20314C18.0781 8.20314 5.96876 9.76564 5.96876 28.9063V29.2188C3.54688 26.5625 1.98438 23.125 1.67188 19.4531C1.28126 14.5313 3.07813 9.68752 6.67188 6.25002C10.2656 2.81252 15.1094 1.17189 20.1094 1.71877C28.2344 2.65627 34.6406 9.92189 34.5625 18.2031C34.3281 22.0313 33.3906 25.4688 31.0469 28.2813L48.2344 43.0469C48.8594 43.5938 49.25 44.375 49.3281 45.2344C49.4063 46.0156 49.0938 46.7969 48.4688 47.4219Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5781 17.6562L21.5156 17.0312C20.1875 14.9218 18.3906 15.1562 18.3125 15.1562L18.4688 16.3281C18.4688 16.2499 19.6406 16.1718 20.5781 17.6562Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 45.4688H14.9531V46.6406H16.125V45.4688Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3906 45.4688H12.2188V46.6406H13.3906V45.4688Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7812 45.4688H17.6094V46.6406H18.7812V45.4688Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7344 45.4688H9.5625V46.6406H10.7344V45.4688Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4375 45.4688H20.2656V46.6406H21.4375V45.4688Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1094 30.7812H8.9375V31.9531H10.1094V30.7812Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1094 33.5156H8.9375V34.6875H10.1094V33.5156Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1094 36.1719H8.9375V37.3438H10.1094V36.1719Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1094 38.8281H8.9375V40H10.1094V38.8281Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2244 40.7011L41.3607 39.9092L40.5687 40.773L41.4325 41.5649L42.2244 40.7011Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4524 42.8087L43.5887 42.0166L42.7966 42.8803L43.6603 43.6723L44.4524 42.8087Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7387 44.8551L45.8747 44.0635L45.0831 44.9275L45.9471 45.7191L46.7387 44.8551Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_937_2538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportNumbers);
export default __webpack_public_path__ + "static/media/reportNumbers.1e59edb6b40ee3fd8918ae5d60ed2d26.svg";
export { ForwardRef as ReactComponent };